import { Film } from "lucide-react";

import { MediaMime } from "../../../api/generated/zod";
import { MediaRefsSlot, type MediaRefs } from "./MediaRefsSlot";

const VIDEO_TYPES = MediaMime.options.filter((mime) => mime.startsWith("video/"));

/**
 * Live's "Video ref" (#260): a reference video's videos, from the library or an upload; a tool's
 * reference videos beside its own are "Video refs" (Kling 4.0 Edit, no live tile).
 */
export function VideoRefSlot({ refs, label = "Video ref" }: { refs: MediaRefs; label?: string }) {
  return (
    <MediaRefsSlot
      label={label}
      tag="Video"
      icon={<Film size={20} strokeWidth={1.5} aria-hidden />}
      accept={VIDEO_TYPES}
      refs={refs}
    />
  );
}
